import { getEnv, useQuery } from '@/utils';
import { Elements, PaymentElement } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import * as React from 'react';
import { useRegister } from '../hooks';

import { getMe, getUsersCardsSetup } from '@/apis';
import { Loader } from '@/components/Common';
import { useState } from 'react';
import './register-form.scss';

// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(getEnv().STRIPE_PUBLISHABLE_KEY);

export const RegisterForm = () => {
  const { data: me } = useQuery({
    queryKey: ['me'],
    queryFn: getMe,
  });

  const { data } = useQuery({
    enabled: !!me,
    queryKey: ['register', me?.id],
    queryFn: () => getUsersCardsSetup({ userId: me?.id }),
  });

  return (
    <div className="stripe-form">
      {data?.client_secret ? (
        <Elements
          stripe={stripePromise}
          options={{ clientSecret: data.client_secret }}
        >
          <CheckoutForm />
        </Elements>
      ) : (
        <div className="stripe-form-loader">
          <Loader />
        </div>
      )}
    </div>
  );
};

const CheckoutForm = () => {
  const { handleSubmit, disabled, isLoading } = useRegister();
  const [ready, setReady] = useState(false);

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement
        onReady={() => {
          setReady(true);
        }}
        options={{
          paymentMethodOrder: ['card'],
          fields: {
            billingDetails: {
              address: {
                country: 'never',
              },
            },
          },
        }}
      />

      {
        <button
          type="submit"
          className="stripe-form-button"
          disabled={disabled || isLoading || !ready}
        >
          {isLoading ? (
            <div className="stripe-form-button-loader">
              <Loader />
            </div>
          ) : (
            '登録する'
          )}
        </button>
      }
    </form>
  );
};
